import api from "./api";

const toQuery = ({ page, limit, search } = {}) => {
  const query = new URLSearchParams();
  if (page != null) query.append("page", String(page));
  if (limit != null) query.append("limit", String(limit));
  if (String(search || "").trim())
    query.append("search", String(search).trim());
  const qs = query.toString();
  return qs ? `?${qs}` : "";
};

const getUnassigned = (path, params = {}) => {
  return api.get(`${path}${toQuery(params)}`);
};

export const getProcessesWithoutTasks = (params = {}) => {
  return getUnassigned(
    "/unassigned-entities/unassigned-processes-without-tasks",
    params,
  );
};

export const getTasksWithoutProcesses = (params = {}) => {
  return getUnassigned(
    "/unassigned-entities/unassigned-tasks-without-processes",
    params,
  );
};

export const getJobsWithoutTasks = (params = {}) => {
  return getUnassigned(
    "/unassigned-entities/unassigned-jobs-without-tasks",
    params,
  );
};

export const getJobsWithoutTable = (params = {}) => {
  return getUnassigned(
    "/unassigned-entities/unassigned-jobs-without-table",
    params,
  );
};

export const getTasksWithoutJobs = (params = {}) => {
  return getUnassigned(
    "/unassigned-entities/unassigned-tasks-without-jobs",
    params,
  );
};
